import * as Yup from "yup";
import "yup-phone";

export const ExportAdminCsvSchema = Yup.object({
  uploadDateFrom: Yup.date()
    .nullable()
    .transform((value, originalValue) =>
      originalValue === null || originalValue === ""
        ? null
        : value)
    .required("From date is required"),
  uploadDateTo: Yup.date()
    .nullable()
    .transform((value, originalValue) =>
      originalValue === null || originalValue === ""
        ? null
        : value)
    .required("To date is required"),
  // email: Yup.string().email("Email is not valid").required("Email cannot be blank"),
});

export const ExportCsvSchema = Yup.object({
  email: Yup.string().email("Email is not valid").required("Email cannot be blank"),
});